"use client";

import React from "react";
import PageNotFoundError from "./PageNotFound";
import SiteExpiredError from "./SiteExpired";
import SiteNotFoundError from "./SiteNotFound";
import UnknownError from "./UnknownError";
import CustomErrorPage from "./CustomErrorPage";
import { ErrorType, ErrorName } from "@/types";

export function Error({ error }: { error: ErrorType }) {
  if (error?.name === ErrorName.WebsiteNotFound) {
    return <SiteNotFoundError />;
  }

  if (error?.name === ErrorName.WebsiteExpired) {
    return <SiteExpiredError />;
  }

  if (error?.name === ErrorName.CustomPageError) {
    return (
      <CustomErrorPage
        pagesMeta={error?.pagesMeta}
        siteData={error?.siteData}
        errorPages={error?.errorPages}
      />
    );
  }

  if (error?.name === ErrorName.PageNotFound) {
    return <PageNotFoundError />;
  }

  return <UnknownError />;
}
